import { FC } from 'react';
import { Typography } from '@mui/material';

import { CardContent, CardHeader } from './Card';
import CollapsibleCard, { CollapsibleCardProps } from '../../../../../components/Card/CollapsibleCard/CollapsibleCard';
import CollapsibleCardExpandArea from '../../../../../components/Card/CollapsibleCard/CollapsibleCardExpandArea';
import CollapsibleCardExpandButton from '../../../../../components/Card/CollapsibleCard/CollapsibleCardExpandButton';
import Row from '../../../../../components/Row';

import { CampaignAdGroup } from '../../../../../types/Campaign';
import CampaignAdGroupOverviewList from '../List/CampaignAdGroupOverviewList';

interface CampaignAdGroupOverviewCardProps {
    campaignAdGroup: CampaignAdGroup;
    slotProps?: {
        collapsibleCard?: Partial<CollapsibleCardProps>;
    };
}

const CampaignAdGroupOverviewCard: FC<CampaignAdGroupOverviewCardProps> = ({ campaignAdGroup, slotProps = {} }) => {
    return (
        <CollapsibleCard
            defaultExpanded
            {...slotProps?.collapsibleCard}
            sx={{
                '& .MuiCardContent-root:last-child': {
                    p: 0,
                },
            }}
        >
            <CardHeader
                title={
                    <Row alignItems="center" gap={1}>
                        <Typography variant="body1">Ad Group Info</Typography>
                    </Row>
                }
                action={<CollapsibleCardExpandButton />}
            />
            <CollapsibleCardExpandArea>
                <CardContent sx={{ p: 0 }}>
                    <CampaignAdGroupOverviewList campaignAdGroup={campaignAdGroup} />
                </CardContent>
            </CollapsibleCardExpandArea>
        </CollapsibleCard>
    );
};

export default CampaignAdGroupOverviewCard;
